import get from 'lodash/get';
import noop from 'lodash/noop';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as PlayerActions from 'src/common/actions/player';
import playerStatuses from 'src/common/utils/playerStatuses';
import { selectAutoPlayGuideItem } from '../selectors/player';

export const syncedPlayerActions = {
  [playerStatuses.playing]: (actions, canScrub) =>
    canScrub ? actions.pause() : actions.stop(),
  [playerStatuses.preroll]: (actions) => actions.pause(),
  [playerStatuses.paused]: (actions) => actions.play(),
  [playerStatuses.stopped]: (actions) => actions.retune(),
  [playerStatuses.failed]: (actions) => actions.retune(),
  [playerStatuses.idle]: (actions, canScrub, guideItem) => {
    if (guideItem) {
      return actions.tune({ guideItem });
    }

    return noop;
  },
};

export function mapStateToProps(state) {
  const { playerStatus, canScrub, tunedGuideId, externalHtmlPlayerUrl } =
    state.player;
  const autoPlayGuideItem = selectAutoPlayGuideItem(state);

  // isMobile is passed through to the PlayTile to disable the play button overlay for mobile only.
  const { isMobile } = state.app;

  return {
    playerStatus,
    canScrub,
    tunedGuideId,
    externalHtmlPlayerUrl,
    isMobile,
    autoPlayGuideItem,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    playerActions: bindActionCreators(PlayerActions, dispatch),
  };
}

export default function connectWithPlayer(MyComponent) {
  /* eslint-disable react/prefer-stateless-function */
  class ConnectWithPlayer extends Component {
    static propTypes = {
      guideItem: PropTypes.object.isRequired,
      playerStatus: PropTypes.string.isRequired,
      playerActions: PropTypes.object.isRequired,
      isMobile: PropTypes.bool.isRequired,
      autoPlayGuideItem: PropTypes.object.isRequired,
      canScrub: PropTypes.bool,
      tunedGuideId: PropTypes.string,
    };

    static defaultProps = {
      autoPlayGuideItem: {},
    };

    render() {
      const { playerStatus, guideItem, tunedGuideId, autoPlayGuideItem } =
        this.props;
      const playGuideId = get(guideItem, 'actions.play.guideId');
      const isPrimedForAutoPlay =
        playerStatus === playerStatuses.idle &&
        playGuideId === autoPlayGuideItem.guideId;
      const isSyncedWithPlayer = !!(
        playGuideId &&
        playGuideId === tunedGuideId &&
        // we still need to tune in the case when !isPrimedForAutoPlay which is why
        // it's not considered to be in sync with player
        !isPrimedForAutoPlay
      );
      const syncedPlayerStatus = isSyncedWithPlayer
        ? playerStatus
        : playerStatuses.idle;

      return (
        <MyComponent
          {...this.props}
          isSyncedWithPlayer={isSyncedWithPlayer}
          syncedPlayerStatus={syncedPlayerStatus}
          syncedPlayerAction={syncedPlayerActions[syncedPlayerStatus] || noop}
        />
      );
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)(ConnectWithPlayer);
}
